/** Helper functions */

export const checkOfficialHasUnsignedAppointmentDocs = (official) => {
  return (
    (official?.uploadChangeDocuments?.appointment?.consentToAct?.templateFile
      ?.modeType === "not-signed-documents" &&
      !official?.uploadChangeDocuments?.appointment?.consentToAct?.signedPdf) ||
    (official?.uploadChangeDocuments?.appointment?.appointmentLetter
      ?.templateFile?.modeType === "not-signed-documents" &&
      !official?.uploadChangeDocuments?.appointment?.appointmentLetter
        ?.signedPdf)
  );
};

export const checkOfficialHasUnsignedCessationDocs = (official) => {
  return (
    (official?.uploadChangeDocuments?.cessation?.letterOfResignation
      ?.templateFile?.modeType === "not-signed-documents" &&
      !official?.uploadChangeDocuments?.cessation?.letterOfResignation
        ?.signedPdf) ||
    (official?.uploadChangeDocuments?.cessation?.statutoryDeclaration
      ?.templateFile?.modeType === "not-signed-documents" &&
      !official?.uploadChangeDocuments?.cessation?.statutoryDeclaration
        ?.signedPdf)
  );
};

export const checkOfficialHasUnsignedChangeOfParticularsDocs = (official) => {
  return (
    (official?.uploadChangeDocuments?.changeOfParticulars?.deedPoll
      ?.templateFile?.modeType === "not-signed-documents" &&
      !official?.uploadChangeDocuments?.changeOfParticulars?.deedPoll
        ?.signedPdf) ||
    (official?.uploadChangeDocuments?.changeOfParticulars?.statutoryDeclaration
      ?.templateFile?.modeType === "not-signed-documents" &&
      !official?.uploadChangeDocuments?.changeOfParticulars
        ?.statutoryDeclaration?.signedPdf)
  );
};

export const checkUnsignedChangesDocsArePresent = (transaction) => {
  return (
    /** Appointment */
    transaction.individualOfficials?.some((official) =>
      checkOfficialHasUnsignedAppointmentDocs(official)
    ) ||
    transaction?.corporateOfficials?.some((official) =>
      checkOfficialHasUnsignedAppointmentDocs(official)
    ) ||
    /** Cessation */
    transaction.individualOfficials?.some((official) =>
      checkOfficialHasUnsignedCessationDocs(official)
    ) ||
    transaction?.corporateOfficials?.some((official) =>
      checkOfficialHasUnsignedCessationDocs(official)
    ) ||
    /** Change Of Particulars */
    transaction.individualOfficials?.some((official) =>
      checkOfficialHasUnsignedChangeOfParticularsDocs(official)
    ) ||
    transaction?.corporateOfficials?.some((official) =>
      checkOfficialHasUnsignedChangeOfParticularsDocs(official)
    )
  );
};

export const checkUnsignedDirectorApprovalDocsArePresent = (transaction) => {
  return transaction?.approvalDocs?.directorApprovalDocs
    ? transaction?.approvalDocs?.directorApprovalDocs?.templateFile.modeType ===
        "not-signed-documents" &&
        !transaction?.approvalDocs?.directorApprovalDocs?.signedPdf
    : false;
};

export const checkUnsignedShareholderApprovalDocsArePresent = (transaction) => {
  return transaction?.approvalDocs?.shareholderApprovalDocs
    ? transaction?.approvalDocs?.shareholderApprovalDocs?.templateFile
        .modeType === "not-signed-documents" &&
        !transaction?.approvalDocs?.shareholderApprovalDocs?.signedPdf
    : false;
};
